export default function downloadFile(href: string, fileName: string) {
    const a = document.createElement("A");

    a.setAttribute("href", href);
    a.setAttribute("download", fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export async function fetchAndDownloadFile(url: string, filename: string) {
    try {
        const response = await fetch(url, { method: "GET" });
        if (!response.ok) throw new Error("Network response was not ok");

        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(link.href);

        return true;
    } catch (error) {
        console.error("Download failed:", error);
        return false;
    }
}
